import { render, staticRenderFns } from "./FormulateAddress.vue?vue&type=template&id=50e2270a&"
import script from "./FormulateAddress.js?vue&type=script&lang=js&"
export * from "./FormulateAddress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e2270a')) {
      api.createRecord('50e2270a', component.options)
    } else {
      api.reload('50e2270a', component.options)
    }
    module.hot.accept("./FormulateAddress.vue?vue&type=template&id=50e2270a&", function () {
      api.rerender('50e2270a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateAddress/FormulateAddress.vue"
export default component.exports